import React from 'react';
import clsx from 'clsx';
import { colorGrayDusk } from '@hse-design/tokens';
import { IconActionDelete } from '../../icons';
import { Icon } from '../Icon';
import { ClickableIcon } from '../ClickableIcon';
import { ButtonPropsWithoutRef } from '../../common/types';

export interface BaseAlertCloseButtonProps extends ButtonPropsWithoutRef {}

export function BaseAlertCloseButton({
  className,
  onClick
}: BaseAlertCloseButtonProps) {
  return (
    <ClickableIcon
      className={clsx('hse-BaseAlert__closeButton', className)}
      iconProps={{
        icon: IconActionDelete,
        size: Icon.Size.medium,
        color: colorGrayDusk
      }}
      onClick={onClick}
    />
  );
}
